/* Partial product-code search.
   Shopify search only matches from the start of a word, so "252" cannot find DH252.
   This keeps a small title index in the browser (refreshed every 12 hours) and
   matches the typed text anywhere inside a product code (first word of the title).
   Used on the search results page and in the header search dropdown. */
(function () {
  'use strict';

  if (window.BigsmallCodeSearchLoaded) return;
  window.BigsmallCodeSearchLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STORE_KEY = 'bsCodeIndex.v1';
  var TTL_MS = 12 * 60 * 60 * 1000;
  var MAX_PAGE_RESULTS = 24;
  var MAX_DROPDOWN_RESULTS = 6;
  var indexPromise = null;

  function norm(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  /* Code = first word of the title. "DH 252" style (letters, space, digits) is joined. */
  function codeOf(title) {
    var parts = String(title || '').trim().split(' ').filter(Boolean);
    var first = parts[0] || '';
    if (parts[1] && /^[A-Za-z]+$/.test(first) && /^[0-9]+$/.test(parts[1])) first += parts[1];
    return norm(first);
  }

  function prepare(items) {
    var out = [];
    items.forEach(function (item) {
      var code = codeOf(item[0]);
      if (code) out.push({ c: code, t: item[0], h: item[1] });
    });
    return out;
  }

  function fetchIndexPage(page) {
    return fetch(ROOT + 'collections/all?view=code-index&page=' + page, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('code index ' + response.status);
        return response.json();
      });
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    indexPromise = new Promise(function (resolve) {
      try {
        var saved = JSON.parse(window.localStorage.getItem(STORE_KEY) || 'null');
        if (saved && saved.t && Date.now() - saved.t < TTL_MS && Array.isArray(saved.d)) {
          resolve(prepare(saved.d));
          return;
        }
      } catch (error) { /* storage unavailable, fall through to network */ }

      fetchIndexPage(1).then(function (first) {
        var jobs = [];
        for (var page = 2; page <= first.pages; page += 1) jobs.push(fetchIndexPage(page));
        return Promise.all(jobs).then(function (rest) {
          var all = first.items.slice();
          rest.forEach(function (chunk) { all = all.concat(chunk.items); });
          try {
            window.localStorage.setItem(STORE_KEY, JSON.stringify({ t: Date.now(), d: all }));
          } catch (error) { /* ignore */ }
          resolve(prepare(all));
        });
      }).catch(function () {
        indexPromise = null;
        resolve([]);
      });
    });
    return indexPromise;
  }

  /* Only code-like searches: short, one code, with at least one digit. */
  function queryKey(raw) {
    var text = String(raw || '').trim();
    if (!text || text.length > 16) return '';
    if (text.replace(/[A-Za-z0-9 _.-]/g, '') !== '') return '';
    var key = norm(text);
    if (!/[0-9]/.test(key)) return '';
    var digitsOnly = /^[0-9]+$/.test(key);
    if (digitsOnly ? key.length < 3 : key.length < 2) return '';
    return key;
  }

  function find(index, key, limit) {
    var digitsOnly = /^[0-9]+$/.test(key);
    var hits = [];
    for (var i = 0; i < index.length; i += 1) {
      var entry = index[i];
      var at = entry.c.indexOf(key);
      if (at === -1) continue;
      var rank;
      if (entry.c === key) rank = 0;
      else if (digitsOnly && entry.c.replace(/[^0-9]/g, '') === key) rank = 1;
      else if (at === 0) rank = 2;
      else if (at + key.length === entry.c.length) rank = 3;
      else rank = 4;
      hits.push({ e: entry, r: rank });
    }
    hits.sort(function (a, b) {
      return a.r - b.r || a.e.c.length - b.e.c.length || (a.e.t < b.e.t ? -1 : 1);
    });
    return hits.slice(0, limit).map(function (hit) { return hit.e; });
  }

  function handleFromHref(href) {
    var text = String(href || '');
    var at = text.indexOf('/products/');
    if (at < 0) return '';
    var rest = text.slice(at + 10).split('?')[0].split('#')[0].split('/')[0];
    try { return decodeURIComponent(rest); } catch (error) { return rest; }
  }

  /* ---------- Search results page ---------- */

  function fetchCard(handle) {
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?view=code-card', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (!html || html.indexOf('data-code-card') === -1) return null;
        var holder = document.createElement('template');
        holder.innerHTML = html.trim();
        return holder.content.querySelector('li[data-code-card]');
      })
      .catch(function () { return null; });
  }

  function buildGrid(page) {
    var empty = page.querySelector('.bigsmall-search-empty');
    if (empty) empty.style.display = 'none';
    page.classList.remove('template-search--empty');

    var wrap = document.createElement('div');
    wrap.className = 'product-grid-container';
    var results = document.createElement('div');
    results.className = 'template-search__results collection page-width';
    var list = document.createElement('ul');
    list.className = 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop';
    list.setAttribute('role', 'list');
    results.appendChild(list);
    wrap.appendChild(results);
    page.appendChild(wrap);
    return list;
  }

  function updateCount(page, term, added, wasEmpty) {
    var el = page.querySelector('.bigsmall-search-page__count');
    if (!el || !added) return;
    if (wasEmpty) {
      el.textContent = added + ' result' + (added === 1 ? '' : 's') + ' for \u201c' + term + '\u201d';
    } else {
      el.textContent = el.textContent.trim() + ' (+' + added + ' matched by product code)';
    }
  }

  function runSearchPage() {
    var page = document.querySelector('.bigsmall-search-page');
    if (!page) return;

    var params = new URLSearchParams(window.location.search);
    var term = params.get('q') || '';
    var key = queryKey(term);
    if (!key) return;

    var pageNo = params.get('page');
    if (pageNo && pageNo !== '1') return;

    var filtered = false;
    params.forEach(function (value, name) {
      if (name.indexOf('filter.') === 0) filtered = true;
    });
    if (filtered) return;

    loadIndex().then(function (index) {
      var matches = find(index, key, MAX_PAGE_RESULTS);
      if (!matches.length) return;

      var grid = page.querySelector('ul.product-grid');
      var wasEmpty = !grid;
      var existing = {};
      if (grid) {
        grid.querySelectorAll(':scope > li').forEach(function (li) {
          var link = li.querySelector('a[href*="/products/"]');
          var handle = link ? handleFromHref(link.getAttribute('href')) : '';
          if (handle) existing[handle] = li;
        });
      }

      return Promise.all(matches.map(function (match) {
        return existing[match.h] || fetchCard(match.h);
      })).then(function (items) {
        items = items.filter(Boolean);
        if (!items.length) return;

        var added = items.filter(function (li) { return !li.isConnected; }).length;
        if (!grid) grid = buildGrid(page);

        var fragment = document.createDocumentFragment();
        items.forEach(function (li) { fragment.appendChild(li); });
        grid.insertBefore(fragment, grid.firstChild);
        updateCount(page, term, added, wasEmpty);
      });
    });
  }

  /* ---------- Header search dropdown ---------- */

  function addStyles() {
    if (document.getElementById('bs-code-search-styles')) return;
    var style = document.createElement('style');
    style.id = 'bs-code-search-styles';
    style.textContent = '.bs-code-matches{margin-top:1.2rem;padding-top:1.2rem;border-top:1px solid rgba(0,0,0,.08)}';
    document.head.appendChild(style);
  }

  function buildDropdownBlock(key, matches) {
    var block = document.createElement('div');
    block.className = 'bs-code-matches';
    block.setAttribute('data-key', key);

    var heading = document.createElement('h2');
    heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
    heading.textContent = 'Matching product codes';
    block.appendChild(heading);

    var list = document.createElement('ul');
    list.className = 'predictive-search__results-list list-unstyled';
    list.setAttribute('role', 'group');

    matches.forEach(function (match) {
      var item = document.createElement('li');
      item.className = 'predictive-search__list-item';
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', 'false');

      var link = document.createElement('a');
      link.className = 'predictive-search__item link link--text';
      link.href = ROOT + 'products/' + encodeURIComponent(match.h);
      link.setAttribute('tabindex', '-1');

      var content = document.createElement('div');
      content.className = 'predictive-search__item-content predictive-search__item-content--centered';
      var title = document.createElement('p');
      title.className = 'predictive-search__item-heading h5';
      title.textContent = match.t;

      content.appendChild(title);
      link.appendChild(content);
      item.appendChild(link);
      list.appendChild(item);
    });

    block.appendChild(list);
    return block;
  }

  function initPredictive(predictive) {
    if (!predictive || predictive.getAttribute('data-bs-code-bound') === 'true') return;
    var root = predictive.querySelector('[data-predictive-search]');
    var input = predictive.querySelector('input[type="search"]');
    if (!root || !input) return;
    predictive.setAttribute('data-bs-code-bound', 'true');
    addStyles();

    var counter = 0;
    var queued = false;

    function update() {
      var key = queryKey(input.value);
      var current = root.querySelector('.bs-code-matches');
      if (!key) {
        if (current) current.remove();
        return;
      }
      if (current && current.getAttribute('data-key') === key) return;

      var stamp = counter += 1;
      loadIndex().then(function (index) {
        if (stamp !== counter) return;
        var anchor = root.querySelector('.predictive-search__search-for-button');
        if (!anchor || !anchor.parentNode) return;

        var shown = {};
        root.querySelectorAll('.predictive-search__item--link-with-thumbnail').forEach(function (link) {
          var handle = handleFromHref(link.getAttribute('href'));
          if (handle) shown[handle] = true;
        });

        var matches = find(index, key, MAX_DROPDOWN_RESULTS + 12).filter(function (match) {
          return !shown[match.h];
        }).slice(0, MAX_DROPDOWN_RESULTS);

        var old = root.querySelector('.bs-code-matches');
        if (old) old.remove();
        if (!matches.length) return;
        anchor.parentNode.insertBefore(buildDropdownBlock(key, matches), anchor);
      });
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        update();
      });
    }

    new MutationObserver(schedule).observe(root, { childList: true });
    input.addEventListener('input', schedule, { passive: true });
    schedule();
  }

  function scan(scope) {
    (scope && scope.querySelectorAll ? scope : document).querySelectorAll('predictive-search').forEach(initPredictive);
  }

  function boot() {
    scan(document);
    runSearchPage();
  }

  document.addEventListener('focusin', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('predictive-search input[type="search"]')) return;
    initPredictive(target.closest('predictive-search'));
    loadIndex();
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
